module.exports = __webpack_public_path__ + "img/hr-brown-carpet-grass-01.c335aec1.png";